import { render, staticRenderFns } from "./MaterialStatuses.vue?vue&type=template&id=e2846fe4"
import script from "./MaterialStatuses.vue?vue&type=script&lang=js"
export * from "./MaterialStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports